import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type PackagesDeletePackageGroupPresetMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type PackagesDeletePackageGroupPresetMutation = { __typename?: 'Mutation', packagesDeletePackageGroupPreset?: { __typename?: 'packagesPackageGroupPreset', code: string, id: string, sku: string } | null | undefined };


export const PackagesDeletePackageGroupPresetDocument = gql`
    mutation PackagesDeletePackageGroupPreset($id: ID!) {
  packagesDeletePackageGroupPreset(id: $id) {
    code
    id
    sku
  }
}
    `;
export type PackagesDeletePackageGroupPresetMutationFn = Apollo.MutationFunction<PackagesDeletePackageGroupPresetMutation, PackagesDeletePackageGroupPresetMutationVariables>;

/**
 * __usePackagesDeletePackageGroupPresetMutation__
 *
 * To run a mutation, you first call `usePackagesDeletePackageGroupPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePackagesDeletePackageGroupPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [packagesDeletePackageGroupPresetMutation, { data, loading, error }] = usePackagesDeletePackageGroupPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePackagesDeletePackageGroupPresetMutation(baseOptions?: Apollo.MutationHookOptions<PackagesDeletePackageGroupPresetMutation, PackagesDeletePackageGroupPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PackagesDeletePackageGroupPresetMutation, PackagesDeletePackageGroupPresetMutationVariables>(PackagesDeletePackageGroupPresetDocument, options);
      }
export type PackagesDeletePackageGroupPresetMutationHookResult = ReturnType<typeof usePackagesDeletePackageGroupPresetMutation>;
export type PackagesDeletePackageGroupPresetMutationResult = Apollo.MutationResult<PackagesDeletePackageGroupPresetMutation>;
export type PackagesDeletePackageGroupPresetMutationOptions = Apollo.BaseMutationOptions<PackagesDeletePackageGroupPresetMutation, PackagesDeletePackageGroupPresetMutationVariables>;